import { gql } from '@apollo/client/core';

/**
 * Selections for the internal order reads. Keep each in step with the module that maps it — every
 * field selected here is mapped there, and nothing more is selected than is mapped.
 */

export const INTERNAL_ORDER_SUMMARY_FIELDS = gql`
  fragment InternalOrderSummaryFields on Order {
    id
    createdAt
    updatedAt
    state
    fingerprint
    account {
      id
      name
    }
    customer {
      id
      email
      firstName
      lastName
    }
    event {
      id
      name
      timezone
    }
  }
`;

export const INTERNAL_ORDER_DETAIL_FIELDS = gql`
  fragment InternalOrderDetailFields on OrderDetails {
    id
    state
    fingerprint
    transactionId
    customer {
      id
      email
      firstName
      lastName
      phoneNumber
    }
  }
`;
